module.exports = __webpack_public_path__ + "static/media/lunchInactive.0004c4af.png";